<template>
  <div class="remove-workspace">
    <div class="card z-depth-0 remove-panel">
      <div class="card-content">
        <div class="remove-panel-head">
          <div>
            <label class="active teal-text">Principal Removal</label>
            <h5>Move principals out of active processing</h5>
          </div>

          <div class="remove-switch">
            <a
              href="#"
              :class="{ active: type == 'single' }"
              @click.prevent="type = 'single'"
            >
              Single
            </a>
            <a
              href="#"
              :class="{ active: type == 'few' }"
              @click.prevent="type = 'few'"
            >
              Few
            </a>
            <a
              href="#"
              :class="{ active: type == 'bulk' }"
              @click.prevent="type = 'bulk'"
            >
              Bulk
            </a>
          </div>
        </div>

        <div class="remove-note">
          <i class="material-icons">info</i>
          <span>Use this area for administrative removal lists. Review the Bin before final access decisions.</span>
        </div>

        <div class="remove-body">
          <EnrolleeRemoveSingleDiv v-if="type == 'single'" @complete="handleComplete" />
          <EnrolleeRemoveFewDiv v-if="type == 'few'" @complete="handleComplete" />
          <EnrolleeRemoveBulkDiv v-if="type == 'bulk'" @complete="handleComplete" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import EnrolleeRemoveSingleDiv from "@/components/client/onboard/EnrolleeRemoveSingleOnboardComponent.vue";
import EnrolleeRemoveFewDiv from "@/components/client/onboard/EnrolleeRemoveFewOnboardComponent.vue";
import EnrolleeRemoveBulkDiv from "@/components/client/onboard/EnrolleeRemoveBulkOnboardComponent.vue";

export default {
  name: "EnrolleeRemoveOnboardComponent",
  components: { EnrolleeRemoveSingleDiv, EnrolleeRemoveFewDiv, EnrolleeRemoveBulkDiv },
  props: ["cat"],
  setup() {
    const type = ref("single");

    // handle complete
    const handleComplete = (val) => {
      if (val.status && val.reset) {
        type.value = "single"; // back to default
      }
    };

    return {
      handleComplete,
      type,
    };
  },
};
</script>

<style scoped>
.remove-workspace {
  margin-top: 8px;
}

.remove-panel {
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  box-shadow: none;
}

.remove-panel-head {
  align-items: center;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 18px;
}

.remove-panel-head h5 {
  color: #263238;
  font-weight: 700;
  margin: 4px 0 0;
}

.remove-switch {
  background: #eceff1;
  border-radius: 18px;
  display: inline-flex;
  padding: 4px;
}

.remove-switch a {
  border-radius: 14px;
  color: #455a64;
  font-weight: 700;
  padding: 7px 14px;
}

.remove-switch a.active {
  background: #263238;
  color: #ffffff;
}

.remove-note {
  align-items: center;
  background: #fafafa;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  color: #607d8b;
  display: flex;
  gap: 10px;
  margin-bottom: 18px;
  padding: 10px 12px;
}

.remove-note i {
  color: #009688;
  font-size: 20px;
}

.remove-body {
  background: #ffffff;
}

@media (max-width: 700px) {
  .remove-panel-head {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
